/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { PrivateYachtBookingList as PrivateYachtBookingListMole } from "../../molecules";
import { PrivateYachtBookingWrapper } from "./PrivateYachtBooking.style";
import { PrivateYachtBookingListToolbar } from "./PrivateYachtBookingListToolbar";

export const PrivateYachtBookingList: React.FC = () => {
  const { bookingPrivateYachts } = useSelector((state: any) => state.bookings);
  const { loading } = useSelector((state: any) => state.async);
  const [searchBookingId, setSearchBookingId] = React.useState("");
  const filteredBookings = React.useMemo(() => {
    const query = searchBookingId.trim().toLowerCase();
    if (!query) return bookingPrivateYachts;
    return bookingPrivateYachts.filter((booking: any) =>
      String(booking.bookingId || "")
        .toLowerCase()
        .includes(query)
    );
  }, [bookingPrivateYachts, searchBookingId]);
  return (
    <AdminPageBody
      pageToolbar={
        <PrivateYachtBookingListToolbar
          searchBookingId={searchBookingId}
          onSearchBookingIdChange={setSearchBookingId}
        />
      }
    >
      <PrivateYachtBookingWrapper>
        <PrivateYachtBookingListMole
          bookings={filteredBookings}
          loading={loading}
        />
      </PrivateYachtBookingWrapper>
    </AdminPageBody>
  );
};
